<template>
  <component
    :is="rowElement"
    v-bind="$attrs"
    :label="label"
    :class="{ error: hasErrorsBoth }"
    :error="activeErrorMessagesBoth"
  >
    <slot
      :errors="activeErrors"
      :events="events"
      :first-error-message="activeErrorMessagesBoth"
      :has-errors="hasErrorsBoth"
      :validator="preferredValidator"
    />
  </component>
</template> 

<script>
import IcFormRow from "./FormRow";
import IcFormRowHorizontal from "./FormRowHorizontal";
import IcFormRowHorizontal2 from "./FormRowHorizontal2";
import { singleErrorExtractorMixin } from "vuelidate-error-extractor";
import serverSideValidation from "@/ic-common/mixins/serverSideValidation";
import get from "lodash/get";

const _ = { get };

export default {
  props: {
    cols: {
      type: String,
      default: "col-md-offset-4 col-md-8 col-12"
    },
    rowElement: {
      default: "IcFormRowHorizontal"
    }
  },


  mixins: [singleErrorExtractorMixin, serverSideValidation], //singleErrorExtractorMixin],
  components: {
    IcFormRow,
    IcFormRowHorizontal,
    IcFormRowHorizontal2
  }
};
</script>